"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["employee", "occasions", "goalPictureUrl", "charts"],

  data: function data() {
    return {
      userGoals: [],
      dashboardActive: true
    };
  },
  created: function created() {
    this.userGoals = this.getUserHealthGoals();
  },


  methods: {
    getUserHealthGoals: function getUserHealthGoals() {
      if (!this.employee.goals || !this.employee.goals) {
        return [];
      }

      return this.employee.goals;
    },
    updateHealthGoals: function updateHealthGoals(healthGoals) {
      this.userGoals = healthGoals;
    },
    toggleDashboard: function toggleDashboard(isActive) {
      this.dashboardActive = isActive;
    },


    /**
     * Is occasion started
     * @param occasion
     * @returns {boolean}
     */
    occasionStarted: function occasionStarted(occasion) {
      return new Date(occasion.start_date) <= Date.now();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/Dashboard.vue
// module id = z8KN
// module chunks = 1